export function formatDateTime(value) {
  if (!value) return "N/A";
  const date = parseUtcDate(value);
  if (!date) return "N/A";
  return date.toLocaleString("pt-BR");
}

export function parseUtcDate(value) {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === "number") {
    const millis = value > 1e12 ? value : value * 1000;
    const date = new Date(millis);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const raw = String(value).trim();
  if (!raw) {
    return null;
  }

  const hasTimezone = /([zZ]|[+-]\d{2}:?\d{2})$/.test(raw);
  const isIsoWithoutTimezone = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?$/.test(raw);
  const isSpaceSeparatedWithoutTimezone = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(\.\d+)?$/.test(raw);

  const candidate = hasTimezone
    ? raw
    : isIsoWithoutTimezone
      ? `${raw}Z`
      : isSpaceSeparatedWithoutTimezone
        ? `${raw.replace(" ", "T")}Z`
        : raw;

  const date = new Date(candidate);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatElapsedSeconds(totalSeconds) {
  if (totalSeconds == null || Number.isNaN(Number(totalSeconds))) return "N/A";
  const seconds = Math.max(0, Number(totalSeconds));
  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${minutes}min`;
  if (minutes > 0) return `${minutes}min`;
  return `${seconds}s`;
}

export function formatSessionReason(reason) {
  const map = {
    LOGOUT: "Logout",
    NOVO_LOGIN: "Encerrada por novo login",
    ADMINISTRADOR: "Encerrada pelo admin",
    INATIVIDADE: "Expirada por inatividade",
    CONTA_INATIVADA: "Conta inativada",
  };
  return map[reason] || "N/A";
}
